<template>
    <b-card>
        <b-row>
            <h6 class="section-label mx-1 mb-2">
                Promociones
            </h6>
            <b-col cols="12" class="mb-2">
                <b-form-checkbox
                    id="accountSwitch1"
                    name="check-button"
                    switch
                    inline
                >
                    <span>Enviar Promociones</span>
                </b-form-checkbox>
            </b-col>
            <b-col cols="12">
                <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="warning"
                    class="mr-1 mt-1 btn_style"
                >
                    Guardar
                </b-button>
            </b-col>
            <!--/ buttons -->
        </b-row>
    </b-card>
</template>

<script>
import { BButton, BRow, BCol, BCard, BFormCheckbox } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";

export default {
    components: {
        BButton,
        BRow,
        BCol,
        BCard,
        BFormCheckbox
    },
    directives: {
        Ripple
    },
    data() {
        return {};
    }
};
</script>
<style>
.btn_style {
    color: #004e7c !important;
}
</style>
